/**
 * SocialPulseCallbackPage — SPA route `/auth/socialpulse-callback`.
 *
 * A one-hop bridge. The SocialPulse hub redirects the user's browser
 * here (that's the whitelisted redirect URI). Emergent's ingress routes
 * only `/api/*` to the backend, so we forward the same query string
 * onto `/api/auth/socialpulse-callback` via a hard navigation. The
 * backend then exchanges the code, mints the wofy_session cookie, and
 * 302s the user to their original `return_to` URL.
 *
 * A visible loader is shown for the ~500 ms it takes so users don't see
 * a blank page.
 */
import { useEffect } from "react";
import { Loader2 } from "lucide-react";

export default function SocialPulseCallbackPage() {
  useEffect(() => {
    // Preserve the entire query string (?code=…&state=…&error=…).
    const q = window.location.search || "";
    window.location.replace(`/api/auth/socialpulse-callback${q}`);
  }, []);

  return (
    <div
      className="min-h-[60vh] flex flex-col items-center justify-center gap-3 px-6 text-center"
      style={{ background: "#FFF9EF", color: "#1F1A15" }}
      data-testid="socialpulse-callback-loading"
    >
      <Loader2 className="w-6 h-6 animate-spin" style={{ color: "#B25D38" }} />
      <div className="font-display italic text-lg">
        Signing you in with SocialPulse…
      </div>
      <div className="text-xs opacity-70">Hold on — you'll be back on IFT in a moment.</div>
    </div>
  );
}
